/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where the refundable answer came from. `lookup` = rate_refundable_lookup cache hit. `get_terms` = live Travelport call. `rate_not_found` / `request_failure` for error signaling.
 * @export
 */
export const RateRefundableSource = {
    Lookup: 'lookup',
    GetTerms: 'get_terms',
    RateNotFound: 'rate_not_found',
    RequestFailure: 'request_failure'
} as const;
export type RateRefundableSource = typeof RateRefundableSource[keyof typeof RateRefundableSource];


export function instanceOfRateRefundableSource(value: any): boolean {
    for (const key in RateRefundableSource) {
        if (Object.prototype.hasOwnProperty.call(RateRefundableSource, key)) {
            if (RateRefundableSource[key as keyof typeof RateRefundableSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RateRefundableSourceFromJSON(json: any): RateRefundableSource {
    return RateRefundableSourceFromJSONTyped(json, false);
}

export function RateRefundableSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateRefundableSource {
    return json as RateRefundableSource;
}

export function RateRefundableSourceToJSON(value?: RateRefundableSource | null): any {
    return value as any;
}

export function RateRefundableSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): RateRefundableSource {
    return value as RateRefundableSource;
}

